import React from 'react'
import './UpdatePrompt.css'

interface UpdatePromptProps {
  onReload: () => void
}

const UpdatePrompt: React.FC<UpdatePromptProps> = ({ onReload }) => {
  return (
    <div className="update-banner" role="status">
      <span className="update-banner__text">New version available</span>
      <button className="update-banner__action" onClick={onReload}>Update now</button>
    </div>
  )
}

export default UpdatePrompt;
